export enum RoleEnum{
    SUPER_ADMIN="SUPER_ADMIN",
    ADMIN="ADMIN",
    STAFF="STAFF",
    MERCHANT="MERCHANT"
}